import { Routes } from '@angular/router';
import { RootRoute } from './shared/models/angular-routing';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { UnauthorizedComponent } from './pages/public/components/unauthorized/unauthorized.component';
import { liveMapRoutes } from './pages/live-map/live-map.routes';
import { settingsRoutes } from './pages/settings/settings.routes';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: `${RootRoute.MAIN}` },
  { path: 'live-map', pathMatch: 'full', redirectTo: `${RootRoute.MAIN}` },
  {
    path: '',
    component: DashboardLayoutComponent,
    children: [
      {
        path: RootRoute.MAIN,
        loadChildren: () => liveMapRoutes,
      },
    ],
  },
  {
    path: RootRoute.SETTINGS,
    loadChildren: () => settingsRoutes,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
];
